import React, { useContext } from 'react';
import { MDForm } from '../../metadata/MDForm';
import { ProductInfoContext } from '../../data/ApplicationDataSource';
import { ModelContext } from '../../metadata/ModelSource';

export function DriversAndVehiclesForm({ children, content, ...props }) {
  const applicationModel = useContext(ModelContext);
  const { productSetup } = useContext(ProductInfoContext);

  return (
    <MDForm
      model={applicationModel}
      productSetupContext={productSetup.productAttributes}
      presentationMetadata={content}
      extendedAttributes={DriversAndVehiclesFormExtendedAttributes}
    >
      {React.cloneElement(children, { ...props })}
    </MDForm>
  );
}

export const DriversAndVehiclesFormExtendedAttributes = {
  SelectedYourVehicle: {
    label: 'Drivers associated to your household',
    mapping: 'drivers',
    requiredInd: true
  },
};


